import React, { useState } from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    TablePagination,
} from '@material-ui/core';
import moment from 'moment';

const Done = (props) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Card style={{ margin: 10 }}>
            <CardHeader title='Hendelser: Avsluttet' />
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Opprettet</TableCell>
                                <TableCell>Kategori</TableCell>
                                <TableCell>Beskrivelse</TableCell>
                                <TableCell>Meldt av</TableCell>
                                <TableCell>Håndtert av</TableCell>
                                <TableCell>Avsluttet</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.incidentList
                                .filter((incident) => incident.end !== null)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((incident) => {
                                    return (
                                        <TableRow
                                            key={incident.id}
                                            onClick={(evt) => {
                                                props.handleSelect(
                                                    evt,
                                                    incident.id
                                                );
                                            }}
                                            style={
                                                incident.priority === 3
                                                    ? { background: '#D98880' }
                                                    : incident.priority === 2
                                                    ? { background: '#F8C471' }
                                                    : { background: '#82E0AA' }
                                            }
                                        >
                                            <TableCell>{incident.id}</TableCell>
                                            <TableCell>
                                                {moment(incident.start).format(
                                                    'DD.MM-YYYY[, kl. ]HH:mm:ss'
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {incident.catName}
                                            </TableCell>
                                            <TableCell>
                                                {incident.report.slice(0, 20) +
                                                    '...'}
                                            </TableCell>
                                            <TableCell>
                                                {incident.author}
                                            </TableCell>
                                            <TableCell>
                                                {incident.fullName}
                                            </TableCell>
                                            <TableCell>
                                                {moment(incident.end).format(
                                                    'DD.MM-YYYY[, kl. ]HH:mm:ss'
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component='div'
                    count={
                        props.incidentList.filter(
                            (incident) => incident.end !== null
                        ).length
                    }
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} av ${count}`
                    }
                    rowsPerPageOptions={[5, 10, 15, 20]}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage='Rader pr side'
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                />
            </CardContent>
        </Card>
    );
};

export default Done;
